/* eslint-disable no-plusplus */
import { HttpService } from 'core/modules/network-service';
import { get } from 'lodash';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc AccessManagementPermissions defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { AccessManagementPermissionsService } from 'services/accessManagementPermissions';
 *
 * // create service instance and send/cancel request
 * const accessManagementPermissionsService = new AccessManagementPermissionsService();
 * const result = await accessManagementPermissionsService.fetchData( '<user-id>' ); // fetch data
 * accessManagementPermissionsService.cancel(); // cancel an active request
 */
export class AccessManagementPermissionsService extends HttpService {

    // make request and fetch data
    async fetchComponentData(  { url = {}, data = {} } = {} ) {

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: data
            } );

            // extract data
            const visibility = get( response, 'body.component.visibility', {} );
            const state = get( response, 'body.component.data.state', {} );

            const _updatedRoleOptions = get( response, 'body.component.data.options.roleOptions', [] );

            const sliderBreakDownVar = 3;

            const _createInitialSliderMap = ( { index = 0 } = {} ) => {

                const _mapArray = [];
        
                for ( let i = index; i < _updatedRoleOptions.length; i++ ) {
        
                    if ( sliderBreakDownVar === _mapArray.length ) {
                        break;
                    }
        
                    const value = get( _updatedRoleOptions[ i ], 'id', undefined );
                    _mapArray.push( value );
        
                }
        
                return _mapArray;
            };

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    state: state,
                    visibility: visibility,
                    options: get( response, 'body.component.data.options', {} ),
                    structure: get( response, 'body.component.structure', {} ),
                    initialSliderMap: _createInitialSliderMap(),
                    sliderBreakDownVar: sliderBreakDownVar
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    // make request and fetch data
    async submitPermissionsUpdate(  { url = {}, data = {} } = {} ) {

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: { data: data, context: {} }
            } );

            const status = get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE );

            if ( SERVICE_RESPONSE_STATUS.FAILURE === status ) {
                return {
                    status,
                    data: get( response, 'body.component.data', {} )
                };
            }
    
            return {
                status,
                data: get( response, 'body.component.data', {} )
            };

        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
}
